<template>
  <div>
    <!-- header -->
    <div v-if="isShowSearchTest" class="order-test-header">
      <div class="search-label">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path d="M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z" fill="#374957"/>
        </svg>
        <span class="search-label-text">Search Test</span>
      </div>
      <div class="search-input-wrapper">
        <SearchTestInput
          :test-options="testOptions"
          @change="handleSearchTestChange"
          @focus="initializeSearchTest"
          @click.stop
          @keypress.stop
        />
      </div>
    </div>
    <!-- content -->
    <DbsSwitch
      v-if="isShowDbsSwitch"
      class="mt-3 mx-3"
      :dbs-toggle="dbsToggle"
      @change="changeDbsVersion"
    />
    <!-- <CovidAlert class="mt-3 mx-3" /> -->
    <MenuSwitchDialog
      :is-show-dbs-dialog="isShowMenuSwitchDialog"
      :discard-list="discardItemList"
      :different-price-list="differentPriceItemList"
      :same-price-list="samePriceItemList"
      @closeWithCancel="closeDbsDialog"
      @closeWithProceed="closeWithProceed"
    />
    <div class="order-test-panel-wrapper">
      <OrderTestTabs
        :searched-item="searchedItem"
        :selectProp="selectProp"
        :isNotAllowedSelectProp="isNotAllowedSelectProp"
        :order-test-support-obj="orderTestSupportObj"
        :is-show-merch-tab="isShowMerchTabParent"
        :is-show-discount-panel-tab="false"
        :display-item-data="displayItemData"
        :custom-panel-list="customPanelList"
        :highlight-list="highlightList"
        :is-show-highlight-tab="isShowHighlightTab"
        :is-show-shortcut-bundles-tab="isShowShortcutBundlesTab"
        @shortcut-selection-change="handleShortcutSelectionChange"
      />
    </div>
  </div>
</template>

<script>
import MenuSwitchDialog from "./menu-switch-dialog/index.vue";
import DbsSwitch from "./DbsSwitch.vue";
import SearchTestInput from "../SearchTestInput.vue";
import OrderTestTabs from "./order-test-tabs/index.vue";
// import CovidAlert from "./CovidAlert.vue";
import { mapState, mapGetters } from "vuex";
import _ from "lodash";
import { getTestAndBundleOptions, getAffectedItemLists } from "./index.js";
import { getAllDescendants } from "@/utils/va-order-test/testAndPanelSelection/testSelection";
import { getMerchandiseOptions } from "./helpers.js";
export default {
  components: {
    MenuSwitchDialog,
    DbsSwitch,
    SearchTestInput,
    OrderTestTabs,
    // CovidAlert,
  },
  props: {
    orderDraft: {
      type: Object,
      default: () => {},
    },
    isShowDbsSwitch: {
      type: Boolean,
      default: false
    },
    isShowSearchTest: {
      type: Boolean,
      default: true
    },
    selectProp: {
      type: String,
      default: "isSelect"
    },
    isNotAllowedSelectProp: {
      type: String,
      default: "isNotAllowedSelect"
    },
    orderTestSupportObj: {
     type: Object,
     default: () => {}
    },
    displayItemData: {
      type: Object,
      default: null
    },
    isShowMerchTabParent: {
      type: Boolean,
      default: true,
    },
    customPanelList: {
      type: Array,
      default: () => [],
    },
    highlightList: {
      type: Array,
      default: () => [],
    },
    isShowHighlightTab: {
      type: Boolean,
      default: false,
    },
    isShowShortcutBundlesTab: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchedItem: {},
      testOptions: [],
      dbsToggle: this.$store.state.orderTest.isDbsVersion,
      isShowMenuSwitchDialog: false,
      discardItemList: [],
      differentPriceItemList: [],
      samePriceItemList: [],
      haveChosenDraftItems: false,
    };
  },

  computed: {
    ...mapState("orderTest",[
      "switchToDbs",
      "switchToSerum",
      "discountMap",
      "isDbsVersion",
      "isAddOnOrder",
      "defaultSettings"
    ]),
    ...mapState("orderTest/user", ["userInfo"]),
    ...mapState("orderTest/tests", ["isVaPanelHidden"]),
    ...mapGetters("orderTest/merchandise", ["formattedMerchList"]),

    // Access properties from displayItemData
    testNodeList() {
      return this.displayItemData?.bfsTestList || [];
    },
    testList() {
      return this.displayItemData?.testList || [];
    },
    serumCategorizedVwTests() {
      return this.displayItemData?.serumCategorizedVwTests || [];
    },
    dbsCategorizedVwTests() {
      return this.displayItemData?.dbsCategorizedVwTests || [];
    },
    regenereNodeList() {
      return this.displayItemData?.regenereNodeList || [];
    },
    nutriprozNodeList() {
      return this.displayItemData?.nutriprozNodeList || [];
    },
    bundleList() {
      return this.displayItemData?.bundleList || [];
    },
    // Compute discount panel lists from bundleList
    discountPanelList() {
      return this.displayItemData?.discountPanelList || [];
    },
    serumDiscountPanelList() {
      return this.displayItemData?.serumDiscountPanelList || [];
    },
    dbsDiscountPanelList() {
      return this.displayItemData?.dbsDiscountPanelList || [];
    },

    // Access properties from orderTestSupportObj
    dbsMap() {
      return this.orderTestSupportObj?.dbsMap || [];
    },
    selectedSeasonalPromoList() {
      return this.orderTestSupportObj?.selectedSeasonalPromoList || [];
    },
    editOrderItemList() {
      return this.orderTestSupportObj?.editOrderItemList || [];
    },
    // Compute selected lists from orderTestSupportObj
    selectedTestList() {
      if (!this.orderTestSupportObj?.selectedTestIdList || !this.testList) return [];
      return this.testList.filter(test =>
        this.orderTestSupportObj.selectedTestIdList.includes(test.id)
      );
    },
    selectedDiscountPanelList() {
      if (!this.orderTestSupportObj?.selectedDiscountPanelIdList || !this.bundleList) return [];
      return this.bundleList.filter(panel =>
        panel.category === "discountPanel" &&
        this.orderTestSupportObj.selectedDiscountPanelIdList.includes(panel.bundleId)
      );
    },
    selectedCustomPanelList() {
      if (!this.orderTestSupportObj?.selectedCustomPanelIdList || !this.bundleList) return [];
      return this.bundleList.filter(panel =>
        panel.category === "customPanel" &&
        this.orderTestSupportObj.selectedCustomPanelIdList.includes(panel.bundleId)
      );
    },
    selectedXChooseYPanelList() {
      if (!this.orderTestSupportObj?.selectedXChooseYPanelIdList || !this.bundleList) return [];
      return this.bundleList.filter(panel =>
        this.orderTestSupportObj.selectedXChooseYPanelIdList.includes(panel.bundleId)
      );
    },
    selectedShortcutList() {
      if (!this.orderTestSupportObj?.selectedShortcutIdList || !this.orderTestSupportObj?.shortcutList) return [];
      return this.orderTestSupportObj.shortcutList.filter(shortcut =>
        this.orderTestSupportObj.selectedShortcutIdList.includes(shortcut.id)
      );
    },

    changeVersionSupportObj() {
      return {
        selectedTestList: this.selectedTestList,
        selectedDiscountPanelList: this.selectedDiscountPanelList,
        selectedCustomPanelList: this.selectedCustomPanelList,
        selectedXChooseYPanelList: this.selectedXChooseYPanelList,
        selectedSeasonalPromoList: this.orderTestSupportObj?.selectedSeasonalPromoList || [],
        selectedShortcutList: this.selectedShortcutList,
        dbsMap: this.orderTestSupportObj?.dbsMap || [],
        testList: this.testList,
        bundleList: this.orderTestSupportObj?.bundleList || [],
        editOrderItemList: this.orderTestSupportObj?.editOrderItemList || []
      }
    },
  },

  watch: {
    serumDiscountPanelList() {
      this.getSearchTestOptions();
    },

    serumCategorizedVwTests() {
      this.getSearchTestOptions();
    },

    isVaPanelHidden() {
      this.getSearchTestOptions();
    },

    switchToDbs() {
      if (!this.dbsToggle) {
        this.changeDbsVersion(true);
      }
    },

    switchToSerum() {
      if (this.dbsToggle) {
        this.dbsToggle = false;
        this.changeDbsVersion(false);
      }
    },

     isDbsVersion(newVal) {
      this.dbsToggle = newVal;
    },
  },


  mounted() {
    this.getSearchTestOptions();
  },

  methods: {
    getSearchTestOptions() {
      let discountPanels = this.dbsToggle
        ? this.dbsDiscountPanelList
        : this.serumDiscountPanelList;
      // get test lists
      let vaTestList = this.isVaPanelHidden ? [] : this.testList.filter(test => test.category === "va");
      let vwTestList = [];
      let categorizedVwTests = this.isDbsVersion
        ? this.dbsCategorizedVwTests : this.serumCategorizedVwTests;
      categorizedVwTests.forEach((category) => {
        // add both vw test and its descendants to test options
        category.testNodeList.forEach(node => {
          let descendantList = [];
          getAllDescendants(node, descendantList);
          vwTestList.push(node.value);
          vwTestList = vwTestList.concat(descendantList.map(node => node.value));
        });
      });
      // add regenere tests to test options
      let regenereTestList = this.regenereNodeList.map(node => node.value);
      // add nutriproz tests to test options
      let nutriprozTestList = this.nutriprozNodeList.map(node => node.value);
      let testList = (this.isDbsVersion ? vwTestList : vaTestList.concat(vwTestList))
        .concat(regenereTestList)
        .concat(nutriprozTestList)
        .filter(test => !test.toBeOffline);
      this.testOptions = getTestAndBundleOptions(testList, discountPanels)
        .concat(getMerchandiseOptions(this.formattedMerchList.filter(e => e.isShow))); // concat merch list to test options for search
      this.$store.dispatch("orderTest/setSearchTestOptions", this.testOptions);
    },

    handleSearchTestChange(item) {
      if (item && item.isMerch) {
        this.$store.dispatch("orderTest/merchandise/setSearchedMerchId", item.id);
      }
      this.searchedItem = item;
    },

    initializeSearchTest() {
      if (this.searchedItem && this.searchedItem.isMerch) {
        this.$store.dispatch("orderTest/merchandise/deleteSearchedMerchId")
      }
      this.searchedItem = {};
    },

    changeDbsVersion(dbsToggle) {
      this.dbsToggle = dbsToggle;
      let { discardItemList, differentPriceItemList, samePriceItemList } = getAffectedItemLists(dbsToggle, this.changeVersionSupportObj);
      this.discardItemList = discardItemList;
      this.differentPriceItemList = differentPriceItemList;
      this.samePriceItemList = samePriceItemList;
      if (discardItemList.length > 0 || differentPriceItemList.length > 0) {
        dbsToggle ? this.isShowMenuSwitchDialog = true : this.isShowMenuSwitchDialog = true;
      }
      else {
        samePriceItemList.forEach((item) => {
          let removeTest = dbsToggle ? item.serumTest : item.dbsTest;
          let addTest = dbsToggle ? item.dbsTest : item.serumTest;
          let removePanel = dbsToggle ? item.serumPanel : item.dbsPanel;
          let addPanel = dbsToggle ? item.dbsPanel : item.serumPanel;
          switch (item.category) {
            case "vw":
              this.$store.dispatch("orderTest/removeSelectedTest", removeTest);
              this.$store.dispatch("orderTest/addSelectedTest", addTest);
              break;
            case "discountPanel":
              this.$store.dispatch("orderTest/removeSelectedDiscountPanel", removePanel);
              this.$store.dispatch("orderTest/addSelectedDiscountPanel", addPanel);
              break;
            case "xChooseY":
              this.$store.dispatch("orderTest/removeSelectedMultiChoosePanel", removePanel);
              this.$store.dispatch("orderTest/addSelectedMultiChoosePanel", addPanel);
              break;
            case "seasonalPromo":
              this.$store.dispatch("orderTest/removeSelectedSeasonalPromo", removePanel);
              this.$store.dispatch("orderTest/addSelectedDiscountPanel", addPanel);
              break;
            default:
              break;
          }
        });
        dbsToggle ? this.changeToDbsContent() : this.changeToSerumContent();
      }
    },

    closeDbsDialog() {
      this.isShowMenuSwitchDialog = false;
      this.dbsToggle = !this.dbsToggle;
    },

    changeToDbsContent() {
      this.$store.dispatch("orderTest/setIsDbsVersion", true);
      this.isShowMenuSwitchDialog = false;
      this.getSearchTestOptions();
    },

    changeToSerumContent() {
      this.$store.dispatch("orderTest/setIsDbsVersion", false);
      this.isShowMenuSwitchDialog = false;
      this.getSearchTestOptions();
    },

    closeWithProceed() {
      this.$store.dispatch("orderTest/setIsDbsVersion", this.dbsToggle);
      this.isShowMenuSwitchDialog = false;
      this.getSearchTestOptions();
    },
    handleShortcutSelectionChange(selectedList, totalPrice) {
      this.$emit('shortcut-selection-change', selectedList, totalPrice);
    }
  },
};
</script>

<style scoped>
.title-text {
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  letter-spacing: 0.5148px;
}

.order-test-panel-wrapper {
  border-radius: 10px;
  border: 1px dashed var(--DividerGray, #C4C4C4);
  background: #F9F9F9;
  padding: 12px 8px;
  max-width: 1400px;
  min-height: 600px;
}

.order-test-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 6px;
}

.search-label {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-shrink: 0;
}

.search-label-text {
  overflow: hidden;
  color: var(--color-Grey-Grey-4A, #4A4A4A);
  text-align: right;
  text-overflow: ellipsis;

  /* EHR_TitleS_14_WM */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.1px;
}

.search-input-wrapper {
  flex: 1;
  min-width: 0;
}
</style>
